<agr-page-toolbar
  [isEmpty]="!nedapInstallationsTableConfig || (hasData$ | async) === false"
  [emptyTitle]="'settings.third-parties.no-nedap-installations-title' | translate"
  [emptyDescription]="'settings.third-parties.no-nedap-installations-description' | translate"
  emptyImage="assets/images/pigs_001.jpg"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  [primaryActionText]="'settings.third-parties.add-installation' | translate"
  (primaryAction)="handleAddInstallation()"
  data-test="barn-overview"
>
  <agr-table
    *ngIf="(isLoading$ | async) === false && nedapInstallationsTableConfig && hasData$ | async"
    [config]="nedapInstallationsTableConfig"
    data-test="nedap-installations-table"
  >
  </agr-table>
  <ng-template #animalTypeTemplate let-row="row">
    <mat-select
      [hideSingleSelectionIndicator]="true"
      class="flex__child--auto spacing--margin-right text--small"
      [value]="getSelectedAnimalType(row)"
      [placeholder]="'settings.third-parties.nedap-installation-animal-type' | translate"
      (selectionChange)="selectAnimalType($event, row)"
      data-test="animal-type-column"
    >
      <mat-option *ngFor="let option of animalTypeOptions" [value]="option">
        {{ option.label | translate }}
      </mat-option>
    </mat-select>
  </ng-template>
  <ng-template #secondaryAnimalTypeTemplate let-row="row">
    <mat-select
      *ngIf="getSelectedAnimalType(row) as selectedOption"
      [hideSingleSelectionIndicator]="true"
      class="flex__child--auto spacing--margin-right text--small"
      [value]="getSelectedSecondaryAnimalType(row)"
      [placeholder]="'settings.third-parties.nedap-installation-second-animal-type' | translate"
      (selectionChange)="selectSecondaryAnimalType($event, row)"
      data-test="secondary-animal-type-column"
    >
      <mat-option *ngFor="let option of selectedOption.secondAnimalTypeOptions" [value]="option">
        {{ option.label | translate }}
      </mat-option>
    </mat-select>
  </ng-template>
  <ng-template #thirdAnimalTypeTemplate let-row="row">
    <ng-container *ngIf="getSelectedAnimalType(row) as selectedOption">
      <mat-select
        *ngIf="selectedOption.thirdAnimalTypeOptions"
        [hideSingleSelectionIndicator]="true"
        class="flex__child--auto spacing--margin-right text--small"
        [value]="getSelectedThirdAnimalType(row)"
        [placeholder]="'settings.third-parties.nedap-installation-third-animal-type' | translate"
        (selectionChange)="selectThirdAnimalType($event, row)"
        data-test="third-animal-type-column"
      >
        <mat-option *ngFor="let option of selectedOption.thirdAnimalTypeOptions" [value]="option">
          {{ option.label | translate }}
        </mat-option>
      </mat-select>
    </ng-container>
  </ng-template>
  <ng-template #statusTemplate let-row="row">
    <ng-container *ngIf="row.status === 'Authenticated'; else unauthenticated">{{
      'settings.third-parties.authenticated' | translate
    }}</ng-container>
    <ng-template #unauthenticated
      >{{ 'settings.third-parties.unauthenticated' | translate }}
      <a style="cursor: pointer" (click)="handleAddInstallation()">
        {{ 'settings.third-parties.nedap-connect' | translate }}
      </a>
    </ng-template>
  </ng-template>
  <div *ngIf="(isLoading$ | async) === false && nedapInstallations$ | async">
    <button
      type="submit"
      mat-flat-button
      color="primary"
      (click)="save()"
      style="margin: 10px"
      data-test="nedap-installations__save-button"
    >
      <mat-icon>save</mat-icon>
      {{ 'save' | translate }}
    </button>
  </div>
</agr-page-toolbar>
